<template>
  <div :class="$style.modal" v-if="!loading">
    <UserDiagnosisResultV2
      v-if="shouldShowV2 && result && result.karte.diagnosis.diagnosisSummary"
      :result="result.karte"
      :summary="result.karte.diagnosis.diagnosisSummary"
      :class="$style.modal__result"
      :karte-id="karteId"
    />
    <UserDiagnosisResult v-else :diagnosis-summary="diagnosisSummary" />
    <!-- ばってんマークに変える -->
    <div :class="$style.modal__action">
      <FlatButton @click="$emit('close')" variant="secondary" size="medium">
        戻る
      </FlatButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { DiagnosisSummary } from '@/types/app'
import FlatButton from '@/components/atoms/FlatButton.vue'
import UserDiagnosisResultV2 from '../UserDiagnosisResultV2/UserDiagnosisResultV2.vue'
import UserDiagnosisResult from '@/components/organisms/UserDiagnosisResult/UserDiagnosisResult.vue'
import { useDiagnosisResultModalKarteQuery } from './DiagnosisResultModal.generated'
import { Channel } from '@/types/schema.generated'

const props = defineProps<{
  karteId: string
  diagnosisSummary: DiagnosisSummary
}>()

const NEW_DIAGNOSIS_RESULT_CHANNELS: Channel[] = [
  Channel.Okaneko,
  Channel.Rakuten,
  Channel.Yahoo,
  Channel.Sbi,
  Channel.FourHundredF,
]

const { result, loading, onError } = useDiagnosisResultModalKarteQuery({
  id: props.karteId,
})

const userChannel = computed(() => result.value?.karte.user.channel)

const shouldShowV2 = computed(
  () =>
    result.value?.karte.diagnosis.aiMatchScore != null &&
    result.value?.karte.diagnosis.diagnosisSummary != null &&
    NEW_DIAGNOSIS_RESULT_CHANNELS.includes(
      userChannel.value ?? Channel.Okaneko
    ) &&
    onError(error => {
      if (
        error.graphQLErrors.some(
          e =>
            JSON.stringify(e.path) ===
              JSON.stringify(['karte', 'diagnosis', 'aiMatchScore']) ||
            JSON.stringify(e.path) ===
              JSON.stringify(['karte', 'diagnosis', 'diagnosisSummary'])
        )
      ) {
        return false
      }
    })
)
</script>

<style lang="scss" module>
.modal {
  max-width: 920px;
  padding: 24px;
  background-color: $color-surface-primary;

  &__action {
    display: flex;
    justify-content: flex-end;

    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}
</style>
